<div class="csv-export-dialog">
  <mat-dialog-content>
    <!-- Header with close button -->
    <div class="dialog-header">
      <h2 mat-dialog-title>{{ 'alpr.export.csvExportDialog.title' | t }}</h2>
      <button mat-button (click)="cancel()" class="close-button">
        <sn-icon fontIcon="fa-xmark" fontSet="fas"> </sn-icon>
      </button>
    </div>

    <!-- Provider list -->
    <div class="providers-list">
      <!-- All sources option -->
      <div class="provider-item all-sources" >
        <span class="provider-name">{{ 'alpr.export.csvExportDialogTable.allSources' | t }}</span>
        <div class="provider-line"></div>
        <span class="result-count">{{ 'alpr.export.csvExportDialogTable.allSourcesResults' | t: { count: formatResultCount(data.totalResults.total) } }}</span>
      </div>

      <!-- Description -->
      <p class="description">{{ 'alpr.export.csvExportDialog.description' | t }}</p>

      <!-- Individual providers -->

      <ul class="providers-names-list">
        <li *ngFor="let provider of getFilteredProviders()" class="providers-names-list-item"><span class="">{{ 'alpr.export.csvExportDialogTable.providerName' | t: { provider: getProviderDisplayName(provider) } }}</span></li>
      </ul>
    </div>

    <!-- Info message -->
    <div class="info-message">
      <p>{{ 'alpr.export.csvExportDialog.info' | t }}</p>
    </div>

    <!-- Warning message -->
    <div class="warning-message">
      <p>{{ 'alpr.export.csvExportDialog.warning' | t }}</p>
    </div>
  </mat-dialog-content>

  <!-- Action buttons -->
  <mat-dialog-actions>
    <button mat-button (click)="cancel()">{{ 'common.cancel' | t }}</button>
    <sn-flat-button
          color="accent" (click)="exportAll()">{{ 'alpr.export.csvExportDialog.dialogExportButtonText' | t }}</sn-flat-button>
  </mat-dialog-actions>
</div>
